import React from 'react';
import { Brain, ShieldCheck, AlertTriangle, TrendingUp, Users2, RefreshCw } from 'lucide-react';

const Benefits = () => {
  const benefits = [
    {
      icon: Brain,
      title: 'Stronger Decision Making',
      description:
        'Improve board oversight, strategic thinking, and decision quality across your organisation.',
    },
    {
      icon: ShieldCheck,
      title: 'Improved Accountability',
      description:
        'Create clearer responsibilities, stronger governance structures, and more effective oversight.',
    },
    {
      icon: AlertTriangle,
      title: 'Reduced Governance Risk',
      description:
        'Identify governance weaknesses before they become operational, regulatory, or reputational issues.',
    },
    {
      icon: TrendingUp,
      title: 'Higher Board Performance',
      description:
        'Build more effective boards through stronger leadership, better governance practices, and greater alignment.',
    },
    {
      icon: Users2,
      title: 'Increased Stakeholder Confidence',
      description:
        'Demonstrate good governance to regulators, investors, funders, members, and key stakeholders.',
    },
    {
      icon: RefreshCw,
      title: 'Continuous Improvement',
      description:
        'Move beyond one-off reviews with a repeatable framework for governance maturity and long-term improvement.',
    },
  ];

  return (
    <section id="benefits" className="py-24 md:py-32 px-6 max-w-7xl mx-auto">
      <div className="text-center max-w-3xl mx-auto mb-20">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6 text-ink">
          Better governance.<br className="hidden sm:block"/>
          <span className="highlighter mt-2 sm:mt-4 block">Better outcomes.</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return (
            <div
              key={i}
              className="bg-white border border-ink/5 rounded-3xl p-8 shadow-saas-sm hover:shadow-saas hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="w-14 h-14 rounded-2xl bg-lime flex items-center justify-center mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300">
                <Icon className="w-7 h-7 text-ink" />
              </div>
              <h3 className="text-xl font-bold mb-4 text-ink">{benefit.title}</h3>
              <p className="text-ink/60 leading-relaxed font-medium">{benefit.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Benefits;
